export const FormModeEnum = {
  Add: "Add",
  Edit: "Edit",
}
